// removed by extract-text-webpack-plugin
module.exports = {"base":"FiltersButton_base--2Uibl","icon":"FiltersButton_icon--1weZp"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/FiltersButton/FiltersButton.scss
// module id = 2274
// module chunks = 11